import { render, staticRenderFns } from "./Task.vue?vue&type=template&id=082031c2&scoped=true&"
import script from "./Task.vue?vue&type=script&setup=true&lang=js&"
export * from "./Task.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Task.vue?vue&type=style&index=0&id=082031c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082031c2",
  null
  
)

export default component.exports